<div class="loadal" [class.visible]="isVisible" tabindex="-1" ondragstart="event.preventDefault()">
  <div>
    <img width="100" src="assets/spinner.gif" ondragstart="event.preventDefault()" />
  </div>
</div>
